import Frame1 from '../assets/Frame-1.svg';
import Frame2 from '../assets/Frame-2.svg';
import Frame3 from '../assets/Frame-3.svg';
import Frame4 from '../assets/Frame-4.svg';

export const data = [
    {
        title: 'Adapt your questions to your customers’ responses',
        description: 'Ask unique, personalized, AI follow-up questions to every customer. Go beyond generic responses to unlock deeper, more actionable insights at scale.',
        image: Frame1,
        position: "left"
    },
    {
        title: 'Analyze your data instantly with AI',
        description: 'Group your customer’s responses into actionable themes, understand sentiment development over time and uncover biggest pain points in an instant.',
        image: Frame2,
        position: "right"
    },
    {
        title: 'Turn your survey data into actionable insights',
        description: 'Discover deeper, actionable insights ready to be shared with your team, empowering you to build products your customers would love.',
        image: Frame3,
        position: "left"
    },
    {
        title: 'GDPR Compliant',
        description: 'We have our own ML models, on our own European servers. Your data never leaves our servers. Simple as that.',
        image: Frame4,
        position: "right"
    }
]
